module.exports = __webpack_public_path__ + "static/media/BellGrey.e3b146f4.svg";